var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputadora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.12 42.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daf0f2;}.cls-2{fill:#263980;}.cls-3{fill:#c72318;}.cls-4{fill:#1b1b36;}.cls-5{fill:#e5ab30;}.cls-6{fill:#f8e93c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.84 1.69 13.25 1.69 1.95 21.26 13.25 40.82 35.84 40.82 47.14 21.26 35.84 1.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.85,42.51H12.27L0,21.26,12.27,0H36.85L49.12,21.26Zm-22.6-3.38h20.6L45.17,21.26,34.85,3.38H14.22L3.91,21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.53,30.44a.91.91,0,0,0-.06.11,1.3,1.3,0,0,1-1.28.93H29.6a1.27,1.27,0,0,1-1.32-1.22V29a.16.16,0,0,1,.14-.18h0a5.16,5.16,0,0,1,1.36,0,.89.89,0,0,1,.12.39.37.37,0,0,0,.35.33h5.32a.34.34,0,0,0,.31-.33,3.21,3.21,0,0,0,0-.62.34.34,0,0,0-.34-.34H31.49a.89.89,0,0,1-.53-.1,2.64,2.64,0,0,1,0-1.25.77.77,0,0,1,.53-.11h4c.28,0,.39-.13.41-.41a5,5,0,0,0,0-.55.33.33,0,0,0-.33-.33H31.5a1.09,1.09,0,0,1-.53-.1,2.68,2.68,0,0,1,0-1.26.86.86,0,0,1,.52-.1h4c.28,0,.39-.13.41-.41.06-.74,0-.84-.76-.84H31.48a1.12,1.12,0,0,1-.51-.08c-.12-.14-.08-.32-.08-.48V14.59c0-.41-.21-.58-.62-.6H28.79c-.5,0-.5,0-.5-.5a.86.86,0,0,1,0-.32,1.28,1.28,0,0,1,1.3-1.24h6.27a1.5,1.5,0,0,1,1.68,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.76,28.88h-6a.16.16,0,0,1-.08.06.55.55,0,0,1-.28.06h-5a.32.32,0,0,1-.3-.12H11.59a.72.72,0,0,1-.77-.42V14.26a.72.72,0,0,1,.8-.44H30.35a.57.57,0,0,1,.64.47v8.3a2.07,2.07,0,0,1,0,1.51v1.21a.33.33,0,0,1,.11.25v1a.3.3,0,0,1-.11.25V28a.51.51,0,0,1,0,.64A1,1,0,0,1,29.76,28.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.69,28.87h0v1.18c0,.24.08.3.3.29a2,2,0,0,1,.6,0,1.23,1.23,0,0,1,1,1c.06.19,0,.29-.22.29h-9c-.36,0-.4-.06-.28-.41a1.28,1.28,0,0,1,1.21-.87H18c.12-.16.29-.12.45-.12h4.23c.79,0,.8,0,.81-.8C23.57,29.22,23.51,29,23.69,28.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.69,28.87v1.25c0,.17-.06.23-.23.23H18.05V28.9h5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.76,28.88h.41c.64,0,.79-.14.84-.78h4.7c.24,0,.34.06.32.32s0,.68,0,1c0,.15-.06.21-.22.21H30c-.16,0-.22-.06-.21-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31,26.88V25.33h4.72c.23,0,.31,0,.3.29a8.34,8.34,0,0,0,0,1c0,.23-.07.3-.3.3H31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31,24.12V22.61h4.85c.15,0,.22,0,.22.2v1.12c0,.14,0,.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.85,16.5a1.25,1.25,0,1,1,1.27-1.23,1.25,1.25,0,0,1-1.27,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M20.9,26.1H12.23c-.34,0-.34,0-.34-.34V15.27c0-.34,0-.34.35-.34h17.3c.36,0,.36,0,.36.35V25.75c0,.35,0,.35-.36.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.14,27.49a.73.73,0,0,1,.7-.76h.05a.76.76,0,1,1-.75.77Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputadora);
export default __webpack_public_path__ + "static/media/computadora.1f4197a848db9ecf6d95987057e1bad5.svg";
export { ForwardRef as ReactComponent };